<!-- PDFサムネイル表示コンポーネント(DB格納済み(S3)ファイル用) -->
<template>
    <div class="pdf-document">
        <div :id="id" style="position:relative; height:260px;">
            <slot></slot>
            <v-overlay :absolute="true" :value="isLoading" :z-index=1>
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </div>
    </div>
</template>

<script>
import * as pdfjsLib from 'pdfjs-dist';
import "pdfjs-dist/web/pdf_viewer.css";

export default {
    props: [
        'pdfData',
        'scale',
        'maxWidth',
        'suffixes'
    ],
    data() {
        return {
            isLoading: false,
            id: 'dbFile_' + this.suffixes,
        };
    },
    created() {
        pdfjsLib.GlobalWorkerOptions.workerSrc = "/documents/js/pdf.worker.js";
        // this.fetchPDF();
    },
    async mounted() {
        // const pdfjsLib = require('pdfjs-dist')
        // pdfjsLib.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.min.js')
        // const pdf = await pdfjsLib.getDocument({
        //     url: '/storage/test.pdf',
        //     cMapUrl: '/storage/cmaps/',
        //     cMapPacked: true
        // }).promise;
        
        this.setLoading(true);
        this.$emit('loading', true);
        // let loadingTask = pdfjsLib.getDocument(this.pdfUrl);
        // console.log(this.pdfData);
        let loadingTask = pdfjsLib.getDocument({
            data: window.atob(this.pdfData),
            cMapUrl: '/documents/cmaps/',
            cMapPacked: true,
        });
        
        let loadpdf = await loadingTask.promise;

        const page = await loadpdf.getPage(1);
        const viewport = page.getViewport({ scale: this.scale });
        // console.log(viewport);
        
        var scale = Math.min((259 / viewport.height), (195 / viewport.width));
        // console.log((260 / viewport.height));
        // console.log((196 / viewport.width));
        // console.log(scale);
        
        var reViewport = page.getViewport({ scale: scale });

        const canvas = document.createElement('canvas');
        canvas.height = reViewport.height;
        canvas.width = reViewport.width;

        document.getElementById(this.id).appendChild(canvas);
        await page.render({
            canvasContext: canvas.getContext('2d'),
            viewport: reViewport
        }).promise;
        
        this.setLoading(false);
    },
    methods: {
        setLoading: function (loading) {
            this.isLoading = loading;
        },
    }
};
</script>

<style scoped>
    .pdf-document {
        border: 1px solid #aaa;
        border-radius: 2px;
        margin-bottom: 10px;
    }
</style>
